export class LandingPage {
    constructor(app) {
        this.app = app;
    }
    render() {
        return `
            <div class="card">
                <h1>Welcome to the PDH Prototype</h1>
                <p>This is a demonstration of the <strong>Proprietary Data Asset Engine</strong>. You are about to embark on a guided journey to define your core identity, establishing the foundation for a truly personalized and intelligent system.</p>
                <div class="button-container">
                    <button id="get-started" class="button-primary">Begin Asset Creation</button>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        var _a;
        (_a = document.getElementById('get-started')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.app.nextStep();
        });
    }
}
